module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3461594.a440a122.png";